import type { ReactElement } from 'react'
import { AddUserPage } from '@components'
import type { WithCompanyId } from '@terros/common'
import { useRequiredParams } from '@util'
import { createFileRoute } from '@tanstack/react-router'

function Add(): ReactElement {
  const { companyId } = useRequiredParams<WithCompanyId>()

  return <AddUserPage companyId={companyId} />
}

export const Route = createFileRoute('/companies_/$companyId_/user_/add/')({
  component: Add,
})
